import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AppComponent } from "../app.component";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { Service } from "../services";
import { LoadingScreenService } from "../services/loading-screen/loading-screen.service";
import { GlobalService } from "../global.service";
import { MatDialog, MatDialogConfig, MAT_DIALOG_DATA } from "@angular/material";
import { AlertasComponent } from "../alertas/alertas.component";
//import {AngularFireAnalytics} from '@angular/fire/analytics';
import { environment } from "../../environments/environment";
import { PaymentSupportService } from "../flash-payment/flash-payment-core/services/payment-support.service";
import { MfaService } from "../mfa/services/mfa.service";
import { FlashApiService } from "../flash-payment/flash-payment-core/services/flash-api.service";
import { MessageService } from "../message.service";

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.sass"],
})
export class LoginComponent implements OnInit {
  public tokenExternal = "";
  loginForm: FormGroup;
  siteKey: string;
  public ipAddress: string = "";

  constructor(
    public global: GlobalService,
    private route: ActivatedRoute,
    private loadingScreenService: LoadingScreenService,
    private router: Router,
    private formBuilder: FormBuilder,
    public appComponent: AppComponent,
    private services: Service,
    public dialog: MatDialog,
    // public AngularFireAnalytics: AngularFireAnalytics,
    private mfaService: MfaService,
    private flashApiService: FlashApiService,
    private paymentSupportService: PaymentSupportService,
    private messageService: MessageService
  ) {
    // this.AngularFireAnalytics.setCurrentScreen("Iniciar Sesión");
    // this.AngularFireAnalytics.logEvent("Iniciar Sesión-Screenview");
    this.siteKey = this.global.siteKey;
    this.global.isIframe = false;
  }

  evaluateDataFromRedirect() {
    this.loadingScreenService.startLoading();
    console.log(this.router.parseUrl(this.router.url).queryParams.userdata);
    if (this.router.parseUrl(this.router.url).queryParams["userdata"]) {
      const userdata = this.router.parseUrl(this.router.url).queryParams[
        "userdata"
      ];
      console.log(JSON.parse(atob(userdata)));
      const decriptedData = JSON.parse(atob(userdata));
      this.callUserdata(decriptedData);
      this.global.isIframe = true;
    } else if (this.router.parseUrl(this.router.url).queryParams["token"]) {
      this.global.isIframe = true;
      const token = this.router.parseUrl(this.router.url).queryParams["token"];
      const account = this.router.parseUrl(this.router.url).queryParams[
        "account"
      ];
      const subscriber = this.router.parseUrl(this.router.url).queryParams[
        "subscriber"
      ];
      const decriptedData = {
        currentSuscriber: subscriber,
        selectBan: account,
        token,
      };
      sessionStorage.setItem("selectBan", btoa(account));
      sessionStorage.setItem("userdataIframe", JSON.stringify(decriptedData));
      sessionStorage.setItem("token", token);
      sessionStorage.setItem("isIframe", "true");
    //  debugger;
      this.getAccountClaroFromtoken(token, account, subscriber);
    } else {
      this.createForm();
    }
  }

  callUserdata(decriptedData) {
    this.authenticateToken(decriptedData);
  }

  authenticateToken(decriptedData) {
    this.loadingScreenService.startLoading();
    this.services.authenticateToken(decriptedData.SSOAccessToken).subscribe(
      (resp: any) => {
        if (resp.hasError) {
          this.loadingScreenService.stopLoading();
          this.messageService.sentMessage("canceled", {
            method: "Error obteniendo informacion de usuario",
          });
          this.global.notif(resp.errorDisplay);
        } else {
          sessionStorage.setItem(
            "userdataIframe",
            JSON.stringify(decriptedData)
          );
          sessionStorage.setItem("token", resp.token);
          sessionStorage.setItem("isIframe", "true");
          this.loadLogin(resp);
        }
      },
      (error) => {
        this.loadingScreenService.stopLoading();
        this.messageService.sentMessage("canceled", {
          method: "Error obteniendo informacion de usuario",
        });
      }
    );
  }

  getAccountClaroFromtoken(token, account, subscriber) {
    this.loadingScreenService.startLoading();
    this.services
      .accountDetails(token, btoa(subscriber), btoa(account))
      .subscribe(
        (data: any) => {
          if (data) {
            if (
              data.AccounInfo.bANField &&
              data.AccounInfo.accountSubtypeField &&
              data.AccounInfo.accountTypeField
            ) {
              const accountList = [
                {
                  account: data.AccounInfo.bANField,
                  accountID: null,
                  accountSubType: data.AccounInfo.accountSubtypeField,
                  accountType: data.AccounInfo.accountTypeField,
                  active: true,
                  defaultAccount: false,
                  guest: false,
                  productType: "",
                  registerDate: "",
                  subsriberByDefault: "",
                  userID: null,
                  userName: "",
                },
              ];

              sessionStorage.setItem(
                "AccountList",
                btoa(JSON.stringify(accountList))
              );
              sessionStorage.setItem(
                "accountInfo",
                JSON.stringify(data.AccounInfo)
              );
              sessionStorage.setItem(
                "subscriberInfo",
                JSON.stringify(data.SubscriberInfo)
              );
              if (data.HasError == false) {
                if (data.AccounInfo.billBalanceField != null) {
                  data.AccounInfo.billBalanceField =
                    data.AccounInfo.billBalanceField.replace(",", "");
                }
                sessionStorage.setItem(
                  "getAccountDetails",
                  btoa(JSON.stringify(data))
                );
                this.global.session();

                if (
                  JSON.parse(atob(sessionStorage.getItem("getAccountDetails")))
                    .SubscriberInfo.length > 0
                ) {
                  if (
                    JSON.parse(
                      atob(sessionStorage.getItem("getAccountDetails"))
                    ).SubscriberInfo[0].prepaidBalanceField !== null
                  ) {
                    sessionStorage.setItem(
                      "prepaidBalance",
                      btoa(
                        JSON.stringify(
                          JSON.parse(
                            atob(sessionStorage.getItem("getAccountDetails"))
                          ).SubscriberInfo[0].prepaidBalanceField.toString()
                        )
                      )
                    );

                    if (
                      JSON.parse(
                        atob(sessionStorage.getItem("prepaidBalance"))
                      ).search("CR") > -1
                    ) {
                      sessionStorage.setItem("prepaidBalance", btoa("0"));
                    }
                  }

                  sessionStorage.setItem(
                    "socRateField",
                    btoa(
                      JSON.parse(
                        atob(sessionStorage.getItem("getAccountDetails"))
                      ).SubscriberInfo[0].planInfoField.socRateField
                    )
                  );
                  console.log("redirigiendo");
                  this.router.navigate(["changeplan"]);
                }
              } else {
                this.loadingScreenService.stopLoading();
                this.global.notif(data.errorDisplay);
              }
            } else {
              this.messageService.sentMessage("canceled", {
                method: "Error obteniendo informacion de usuario",
              });
              this.global.notif(
                "Ha ocurrido un error consultando tus datos, por favor intenta nuevamente más tarde"
              );
            }
          } else {
            this.messageService.sentMessage("canceled", {
              method: "Error obteniendo informacion de usuario",
            });
            this.global.notif(
              "Ha ocurrido un error consultando tus datos, por favor intenta nuevamente más tarde"
            );
          }
        },
        (error2) => {
          this.loadingScreenService.stopLoading();
          this.messageService.sentMessage("canceled", {
            method: "Error obteniendo informacion de usuario",
          });
          this.global.notif(
            "Ha ocurrido un error consultando tus datos, por favor intenta nuevamente más tarde"
          );
          console.log(error2);
        }
      );
  }

  private createForm() {
    this.loginForm = this.formBuilder.group({
      username: ["", Validators.required],
      password: ["", Validators.required],
      remember: false,
      recaptcha: ["", Validators.required],
    });
  }

  ngOnInit() {
    this.evaluateDataFromRedirect();
    console.log(environment.version);
    //if (this.services.externalLoginPath == null) {
    //  this.global.signOff();
    //}
    //this.route.queryParams.subscribe((params) => {
    //  if (params && params.token) {
    //    this.tokenExternal = params.token;
    //    this.loginExternal();
    //  }
    //});
  }

  getIn(event) {
    if (event.key) {
      if (event.key == "Enter") {
        this.login();
      } else {
        this.global.validateInputKey(event);
      }
    } else {
      this.global.validateInputKey(event);
    }
  }

  loadLogin(data: any, username = "") {
    let idUser: number;
    let objAccounts;
    let userName2: string;
    if (data.userPaymentVersion === "P2P") {
      sessionStorage.setItem("canUseNewMethod", "true");
    }
    if (data.hasError == false) {
      sessionStorage.setItem("activeNavigation", "true");
      objAccounts = data.accounts;
      sessionStorage.setItem("objAccounts", JSON.stringify(data.accounts));
      idUser = objAccounts.AccountList[0].userID;
      sessionStorage.setItem("token", data.token);
      localStorage.setItem("tokenExternal", data.token);
      // var requiredEmailUpdate = data.requiredEmailUpdate;
      // var requiredAccountUpdate = data.requiredAccountUpdate;
      sessionStorage.setItem("email", btoa(data.email));
      sessionStorage.setItem("userId", btoa(idUser.toString()));
      sessionStorage.setItem("selectBan", btoa(data.account));
      sessionStorage.setItem("logState", btoa(JSON.stringify(false))); // revisar
      sessionStorage.setItem("SSOAccessToken", data.SSOAccessToken);
      this.global.ssoToken = data.SSOAccessToken;
      sessionStorage.setItem("SSOAccessToken", data.SSOAccessToken);
      let accountName;
      let lastName: string = "";
      let name: string = "";
      if (data.name != "") {
        accountName = data.name.split(" ");
        name = accountName[0] + " " + accountName[1];
        for (let i = 0; i < accountName.length; i++) {
          if (i > 1) {
            lastName = lastName + " " + accountName[i];
          }
        }
        lastName = lastName.trim();
      }

      if (data.requiredPasswordReset == true) {
        this.global.requiredPasswordReset = true;
        this.loadingScreenService.stopLoading();
        this.router.navigate(["forgotpassword"]);
      } else {
        sessionStorage.setItem("userName", data.username);
        if (data.name.length > 20) {
          userName2 = data.name.toString().substring(0, 20) + "...";
          sessionStorage.setItem("name", userName2);
        } else {
          sessionStorage.setItem("name", data.name);
        }
        if (
          accountName[0] == "MR." ||
          accountName[0] == "MRS." ||
          accountName[0] == "MS." ||
          accountName[0] == "SR." ||
          accountName[0] == "SRA."
        ) {
          sessionStorage.setItem("firstName", accountName[1]);
        } else {
          sessionStorage.setItem("firstName", accountName[0]);
        }
        sessionStorage.setItem("userName2", btoa(data.username));
        sessionStorage.setItem("defaultSubscriber", btoa(data.subscriber)); //revisar si se esta guardando
        sessionStorage.setItem(
          "requiredAccountUpdate",
          btoa(JSON.stringify(data.requiredAccountUpdate))
        );
        sessionStorage.setItem("firstload", btoa(JSON.stringify(false))); //revisar
        this.createPermissionPayload(data, name, lastName);
        this.callPermission();
      }
    } else {
      this.loadingScreenService.stopLoading();
      if (
        data.errorNum === 32 ||
        data.errorNum === 33 ||
        data.errorNum === 31 ||
        data.errorNum === 30
      ) {
        let menssageError = data.errorDisplay;
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        dialogConfig.data = {
          inverse: true,
          colorSi: "colorRed",
          colorNo: "colorGray",
          labelSi: "Conectar vía Chat",
          labelNo: "No, gracias",
          menssageError: menssageError,
          messageHtml: false,
          labelTitleHtml: "Bienvenido a Mi Claro Asistencia",
          message: "",
          btmConfirm: true,
        };
        const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
        dialogRef.afterClosed().subscribe((value) => {
          if (value == "continue") {
            this.global.irChat();
            /*let url = this.global.pathChat + '?Email=' + username2 + '&firstname=' + username2 + '&lastname=' + username2 + '&Question=' + 'Problema para iniciar sesión.' + '&Department=' + '16' + '';
            window.open(url, '', 'width=630, height=490,top=100,left=100');*/
          }
        });
      } else if (data.errorNum === 41) {
        this.global.notif(data.errorDisplay);
        this.router.navigate(["loginupdate"]);
        sessionStorage.setItem("token", data.token);
      } else {
        this.global.notif(data.errorDisplay);
      }
    }
  }

  loginExternal() {
    this.loadingScreenService.startLoading();
    this.services.loginExternal(this.tokenExternal).subscribe((data) => {
      this.loadLogin(data);
    });
  }

  login() {
    let username: string = this.loginForm.value.username;
    let password: string = this.loginForm.value.password;
    if (!this.loginForm.invalid) {
      this.loadingScreenService.startLoading();
      this.services.login(btoa(username), btoa(password)).subscribe((data) => {
        this.loadLogin(data, username);
      });
    }
  }

  erase() {
    (<HTMLFormElement>document.getElementById("logsize-b log-mob-b")).reset();
  }

  getIp() {
    this.flashApiService.getIPAddress().subscribe(
      (data: any) => {
        this.ipAddress = data.ip;
      },
      (error) => {
        this.ipAddress = "0.0.0.0";
      }
    );
  }

  createPermissionPayload(data: any, name: string, lastName: string) {
    const payload = {
      data,
      accounts: data.accounts,
      name,
      lastName,
    };

    sessionStorage.setItem("permission-paload", JSON.stringify(payload));
  }

  validateIfIsNewDevice() {
    const payload = {
      userId: Number(atob(sessionStorage.getItem("userId")!!)),
      userAgent: navigator.userAgent.toLowerCase(),
      brand: "",
      model: "",
      deviceToken: "",
      ip: this.ipAddress,
    };
    console.log(payload);
    this.mfaService.ValidateNewDevice(payload).subscribe(
      (resp: any) => {
        if (resp.data.deviceStatus === "DEVICE_NOT_REGISTERED") {
          this.goToMfa(resp.data.token);
        } else {
          this.callPermission();
        }
      },
      (error) => {
        this.global.errorHandling(error);
      }
    );
  }

  callPermission() {
    const payload = JSON.parse(sessionStorage.getItem("permission-paload")!!);
    var requiredEmailUpdate = payload.data.requiredEmailUpdate;
    var requiredAccountUpdate = payload.data.requiredAccountUpdate;
    var objAccounts = payload.data.accounts;
    this.services
      .permissions(
        payload.data.token,
        payload.data.accountType,
        payload.name,
        payload.lastName
      )
      .subscribe((dataPermission) => {
        if (dataPermission.hasError == false) {
          sessionStorage.setItem(
            "permissions",
            btoa(JSON.stringify(dataPermission))
          );
          sessionStorage.setItem(
            "moduleData",
            btoa(JSON.stringify(dataPermission.permission))
          );
          this.services
            .accountDetails(
              payload.data.token,
              btoa(payload.data.subscriber),
              btoa(payload.data.account)
            )
            .subscribe((data2) => {
              sessionStorage.setItem(
                "accountInfo",
                JSON.stringify(data2.AccounInfo)
              );
              sessionStorage.setItem(
                "subscriberInfo",
                JSON.stringify(data2.SubscriberInfo)
              );
              if (data2.HasError == false) {
                sessionStorage.setItem(
                  "getAccount",
                  btoa(JSON.stringify(objAccounts))
                );
                sessionStorage.setItem(
                  "AccountList",
                  btoa(JSON.stringify(objAccounts.AccountList))
                );
                if (data2.AccounInfo.billBalanceField != null) {
                  data2.AccounInfo.billBalanceField =
                    data2.AccounInfo.billBalanceField.replace(",", "");
                }
                sessionStorage.setItem(
                  "getAccountDetails",
                  btoa(JSON.stringify(data2))
                );
                this.global.session();

                if (
                  JSON.parse(atob(sessionStorage.getItem("getAccountDetails")))
                    .SubscriberInfo.length > 0
                ) {
                  if (
                    JSON.parse(
                      atob(sessionStorage.getItem("getAccountDetails"))
                    ).SubscriberInfo[0].prepaidBalanceField !== null
                  ) {
                    sessionStorage.setItem(
                      "prepaidBalance",
                      btoa(
                        JSON.stringify(
                          JSON.parse(
                            atob(sessionStorage.getItem("getAccountDetails"))
                          ).SubscriberInfo[0].prepaidBalanceField.toString()
                        )
                      )
                    );

                    if (
                      JSON.parse(
                        atob(sessionStorage.getItem("prepaidBalance"))
                      ).search("CR") > -1
                    ) {
                      sessionStorage.setItem("prepaidBalance", btoa("0"));
                    }
                  }

                  sessionStorage.setItem(
                    "socRateField",
                    btoa(
                      JSON.parse(
                        atob(sessionStorage.getItem("getAccountDetails"))
                      ).SubscriberInfo[0].planInfoField.socRateField
                    )
                  );
                }
                /*
            this.global.goToStore(atob(sessionStorage.getItem("selectBan"))).subscribe((e: any) => {

            },error => {
              this.global.notif("Estimado cliente, ha ocurrido un error por favor intentelo mas tarde.");
              this.loadingScreenService.stopLoading();
            }
            );
            */
                sessionStorage.setItem(
                  "popPreguntasSeguridad",
                  btoa(JSON.stringify(payload.data.requiredQuestions))
                );
                if (requiredEmailUpdate === true) {
                  this.router.navigate(["profile/2"]);
                } else if (requiredAccountUpdate === true) {
                  this.router.navigate(["profile/3"]);
                  sessionStorage.setItem("activeNavigation", "false");
                } else {
                  this.global.suspendedAccount(
                    data2.SubscriberInfo[0].subscriberStatusField,
                    payload.data.account,
                    btoa(payload.data.subscriber),
                    data2.AccounInfo.billBalanceField
                  );
                  if (this.services.externalLoginPath == null) {
                    this.global.updateBotChat(payload.data.account);

                    this.router.navigate(["changeplan"]);
                  } else {
                    this.global.cleanExternalLoginPath();
                    this.router.navigate([this.services.externalLoginPath]);
                  }
                }
              } else {
                this.loadingScreenService.stopLoading();
                this.global.notif(data2.errorDisplay);
              }
            });
        } else {
          this.loadingScreenService.stopLoading();

          const dialogConfig = new MatDialogConfig();
          dialogConfig.disableClose = true;
          dialogConfig.autoFocus = true;
          dialogConfig.data = {
            inverse: true,
            messageHtml: true,
            message: dataPermission.errorDesc,
          };
          const dialogRef = this.dialog.open(AlertasComponent, dialogConfig);
          dialogRef.afterClosed().subscribe((value) => {});
        }
      });
  }

  goToMfa(token: string) {
    sessionStorage.setItem("mfa-token", token);
    this.router.navigate(["mfa"]);
  }
}
